'use client';

import Image from "next/image";
import { ConfigurationWall } from "@/types/configuration";
import Button from "./common/Button";

interface Props {
    configurationWall: ConfigurationWall
    actionButton?(): void
}

const WallJumbotron: React.FC<Props> = ({ actionButton, configurationWall }: Props) => {

    return (
        <div
            className="mx-5 lg:mx-10 mb-20 lg:mb-40 px-12 lg:px-32
            relative
                min-h-[36rem] lg:min-h-[54rem] 
                flex justify-center flex-col 
            " >
            <Image src={configurationWall.imageDesktop.src} alt={configurationWall.imageDesktop.alt} className="hidden lg:block rounded-cornerDesk" style={{ objectFit: "cover" }} sizes="100%" fill priority />
            <Image src={configurationWall.imageMobile.src} alt={configurationWall.imageMobile.alt} className="lg:hidden rounded-cornerMob" sizes="100%" style={{ objectFit: "cover" }} fill priority />
            <div className="absolute inset-0 bg-gradient-to-r from-[rgba(0,0,0,0.9)] via-[rgba(0,0,0,0.5) to-transparent opacity-100 rounded-cornerMob lg:rounded-cornerDesk"></div>

            <div className='z-10 w-3/4 lg:w-1/2'>

                <h1 className='text-white mb-5'>
                    {configurationWall.title}
                </h1>
                <Image src={configurationWall.logo.src} alt={configurationWall.logo.alt} height={64} className='mb-5 lg:mb-8' />
                <div className='text-white mb-5 lg:mb-8'>{configurationWall.description}</div>
                {actionButton ? <Button text='Inizia qui' onClick={actionButton} /> : null}
            </div>
        </div>
    )
}

export default WallJumbotron;